import React from 'react';
import { Link } from 'react-router-dom';
import { ShoppingBagIcon, StarIcon } from 'lucide-react';
import { useCart } from '../context/CartContext';
const products = [{
  id: 1,
  name: 'Lavender Essential Oil',
  price: 'KSh 1,500',
  priceValue: 1500,
  rating: 5,
  reviews: 124,
  image: 'https://images.unsplash.com/photo-1595981267035-7b04ca84a82d?q=80&w=600&auto=format&fit=crop',
  description: 'Pure lavender oil for relaxation and skin care.',
  badge: 'Best Seller'
}, {
  id: 2,
  name: 'Tea Tree Essential Oil',
  price: 'KSh 1,200',
  priceValue: 1200,
  rating: 4.5,
  reviews: 98,
  image: 'https://images.unsplash.com/photo-1608571423902-eed4a5ad8108?q=80&w=600&auto=format&fit=crop',
  description: 'Powerful antiseptic oil with cleansing properties.'
}, {
  id: 3,
  name: 'Eucalyptus Essential Oil',
  price: 'KSh 1,300',
  priceValue: 1300,
  rating: 4.8,
  reviews: 76,
  image: 'https://images.unsplash.com/photo-1600857544200-b2f468e9d10d?q=80&w=600&auto=format&fit=crop',
  description: 'Refreshing oil that promotes clear breathing.',
  badge: 'New'
}, {
  id: 4,
  name: 'Lemongrass Essential Oil',
  price: 'KSh 1,100',
  priceValue: 1100,
  rating: 4.7,
  reviews: 65,
  image: 'https://images.unsplash.com/photo-1601055283742-8b27e81b5553?q=80&w=600&auto=format&fit=crop',
  description: 'Citrusy oil that helps reduce stress.'
}];
const FeaturedProducts = () => {
  const {
    addToCart
  } = useCart();
  return <section className="py-24 bg-[#f8f9f4]" data-id="element-212">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-213">
        <div className="flex flex-col md:flex-row justify-between items-center mb-16" data-id="element-214">
          <div data-id="element-215">
            <div className="inline-flex items-center px-4 py-2 bg-[#f0f7eb] text-[#2e7d32] text-sm font-medium rounded-full mb-4" data-id="element-216">
              <span data-id="element-217">Quality Products</span>
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900" data-id="element-218">
              Featured Products
            </h2>
          </div>
          <Link to="/products" className="mt-6 md:mt-0 px-6 py-3 border border-[#2e7d32] text-[#2e7d32] font-medium rounded-lg hover:bg-[#2e7d32] hover:text-white transition-colors duration-300" data-id="element-219">
            View All Products
          </Link>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-220">
          {products.map(product => <div key={product.id} className="bg-white rounded-2xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-300 group" data-id="element-221">
              <div className="relative" data-id="element-222">
                <div className="aspect-square overflow-hidden" data-id="element-223">
                  <img src={product.image} alt={product.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" onError={e => {
                e.currentTarget.src = 'https://images.unsplash.com/photo-1595981267035-7b04ca84a82d?q=80&w=600&auto=format&fit=crop';
              }} data-id="element-224" />
                </div>
                {product.badge && <div className="absolute top-4 left-4 bg-[#2e7d32] text-white text-xs font-bold px-3 py-1.5 rounded-full" data-id="element-225">
                    {product.badge}
                  </div>}
              </div>
              <div className="p-6" data-id="element-226">
                <div className="flex items-center mb-2" data-id="element-227">
                  <div className="flex" data-id="element-228">
                    {[...Array(5)].map((_, i) => <StarIcon key={i} className={`h-4 w-4 ${i < Math.floor(product.rating) ? 'text-yellow-400 fill-yellow-400' : i < product.rating ? 'text-yellow-400 fill-yellow-400 opacity-50' : 'text-gray-300'}`} data-id="element-229" />)}
                  </div>
                  <span className="text-xs text-gray-500 ml-2" data-id="element-230">
                    ({product.reviews})
                  </span>
                </div>
                <h3 className="font-semibold text-gray-900 group-hover:text-[#2e7d32] transition-colors duration-300" data-id="element-231">
                  {product.name}
                </h3>
                <p className="text-[#2e7d32] font-medium mt-1" data-id="element-232">
                  {product.price}
                </p>
                <p className="text-gray-600 text-sm mt-2 line-clamp-2" data-id="element-233">
                  {product.description}
                </p>
                <button onClick={() => addToCart(product)} className="mt-5 w-full bg-white border border-[#2e7d32] text-[#2e7d32] py-2.5 rounded-lg flex items-center justify-center gap-2 hover:bg-[#2e7d32] hover:text-white transition-colors duration-300 group" data-id="element-234">
                  <ShoppingBagIcon className="h-4 w-4" data-id="element-235" />
                  <span data-id="element-236">Add to Cart</span>
                </button>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
};
export default FeaturedProducts;